const INIT_CUSTOM_SOLUTIONS = [
    {
        name: 'App Marketplace',
        href: '',
    },
    {
        name: 'Partner Ecosystem',
        href: '',
    },
    {
        name: 'Professional Services',
        href: '',
    },
];

export default INIT_CUSTOM_SOLUTIONS;
